export const JULKISIVU_RAKENNEOSA_OPTIONS = [
  'Parvekelaatta',
  'Parvekekaide',
  'Parvekepieli',
  'Julkisivuelementti',
  'Sokkeli',
  'Pilari',
  'Palkki',
];

export const VETOLUJUUS_MURTOTAPA_OPTIONS = [
  'Pääosin runkoainesta myötäillen',
  'Pääosin runkoainesta leikaten',
  'Osittain runkoainesta leikaten',
  'Valusauma',
  'Tartuntapinta',
];

export const VETOLUJUUS_LISAHUOMIOT_OPTIONS = [
  'Teräs murtopinnalla',
];

export const PORANÄYTE_TESTI_OPTIONS = [
  'Veto',
  'Ohuthie',
  'Kloridi',
  'Asbesti',
];

export const RAKENNEOSA_LIST_ID = 'julkisivu-rakenneosa-options';
